import { FluencyOption, PaymentMethod } from './types/agent';

export const brandOptions = [
  { value: 'Brand A', label: 'Brand A' },
  { value: 'Brand B', label: 'Brand B' },
  { value: 'Brand C', label: 'Brand C' },
];

export const currencyOptions = [
  { value: 'USD', label: 'USD' },
  { value: 'EUR', label: 'EUR' },
  { value: 'GBP', label: 'GBP' },
  { value: 'INR', label: 'INR' },
];

export const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  INR: '₹',
};

export const statusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'on_leave', label: 'On Leave' },
  { value: 'terminated', label: 'Terminated' },
];

export const jobApplicationStatusOptions = [
  { value: '', label: 'All' },
  { value: 'InterviewPending', label: 'Interview Pending' },
  { value: 'KimSelected', label: 'Kim Selected' },
  { value: 'ClientSelected', label: 'Client Selected' },
  { value: 'ToBeActioned', label: 'To Be Actioned' },
  { value: 'Rejected', label: 'Rejected' },
  { value: 'NoShow', label: 'No Show' },
  { value: 'Candidate-Not-Interested', label: 'Candidate Not Interested' },
  { value: 'Hold - Prov Selected', label: 'Hold' },
  { value: 'Resigned', label: 'Resigned' },
  { value: 'SeparatedByOps', label: 'Separated by Ops' },
];

export const languageOptions = [
  'English',
  'Dutch',
  'French',
  'German',
  'Spanish',
  'Danish',
];

export const fluencyOptions: FluencyOption[] = [
  { value: 'Spoken', label: 'Spoken' },
  { value: 'Written', label: 'Written' },
];

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const daysOfWeek = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const channelOptions = [
  { value: 'Email', label: 'Email' },
  { value: 'Chat', label: 'Chat' },
  { value: 'Voice', label: 'Voice' },
  { value: 'Social Media Suite', label: 'Social Media Suite' },
];

export const requirementToolOptions = [
  { value: 'Helpdesk', label: 'Helpdesk' },
  { value: 'Calling App', label: 'Calling App' },
  { value: 'Other', label: 'Other' },
];

export const requirementEngagementOptions = [
  { value: 'part-time', label: 'Part Time' },
  { value: 'full-time', label: 'Full Time' },
];

export const requirementTypeOptions = [
  { value: 'customer-support', label: 'Customer Support' },
  { value: 'sales', label: 'Sales' },
  { value: 'social-media', label: 'Social Media' },
  { value: 'others', label: 'Others' },
];

export const tools = [
  { value: 'Gorgias', label: 'Gorgias' },
  { value: 'Zendesk', label: 'Zendesk' },
  { value: 'Freshdesk', label: 'Freshdesk' },
  { value: 'Salesforce', label: 'Salesforce' },
  { value: 'Zoho Desk', label: 'Zoho Desk' },
  { value: 'LiveChat', label: 'LiveChat' },
];

export const paymentMethodOptions: { value: PaymentMethod; label: string }[] = [
  { value: 'paypal', label: 'PayPal' },
  { value: 'payoneer', label: 'Payoneer' },
  { value: 'wise', label: 'Wise' },
  { value: 'bank', label: 'Bank Transfer' },
];

export const allowedTimezones = {
  'Asia/Kolkata': 'India',
  'America/New_York': 'New York (USA)',
  'America/Los_Angeles': 'Los Angeles (USA)',
  'America/Chicago': 'Chicago (USA)',
  'America/Denver': 'Denver (USA)',
  'Pacific/Honolulu': 'Honolulu (USA)',
  'Asia/Manila': 'Philippines',
};

export const allTimezones = [
  { value: 'America/New_York', label: 'Eastern Time (US & Canada)' },
  { value: 'America/Chicago', label: 'Central Time (US & Canada)' },
  { value: 'America/Denver', label: 'Mountain Time (US & Canada)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (US & Canada)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time' },
  { value: 'Europe/London', label: 'London, Dublin (GMT/BST)' },
  { value: 'Europe/Berlin', label: 'Berlin, Paris (CET/CEST)' },
  { value: 'Europe/Moscow', label: 'Moscow Time' },
  { value: 'Africa/Cairo', label: 'Egypt Time (EET)' },
  { value: 'Asia/Dubai', label: 'Dubai Time (GST)' },
  { value: 'Asia/Kolkata', label: 'India Standard Time' },
  { value: 'Asia/Shanghai', label: 'Beijing, Hong Kong' },
  { value: 'Asia/Tokyo', label: 'Tokyo, Seoul' },
  { value: 'Asia/Manila', label: 'Manila Time' },
  { value: 'Australia/Sydney', label: 'Sydney (AEST/AEDT)' },
  { value: 'Etc/UTC', label: 'Coordinated Universal Time (UTC)' },
];

export const DAYS_OF_WEEK = [
  { value: 'monday', label: 'Monday' },
  { value: 'tuesday', label: 'Tuesday' },
  { value: 'wednesday', label: 'Wednesday' },
  { value: 'thursday', label: 'Thursday' },
  { value: 'friday', label: 'Friday' },
  { value: 'saturday', label: 'Saturday' },
  { value: 'sunday', label: 'Sunday' },
];

export const NUMERIC_DAYS_OF_WEEK = [
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
  { value: 0, label: 'Sunday' },
];

export const paymentOptions = [
  { value: 'hourly', label: 'Hourly' },
  { value: 'fixed', label: 'Fixed' },
  { value: 'ticket_based', label: 'Ticket Based' },
];

export const SLACK_ALERT_CHANNELS = [
  { value: '#time-diary-alerts', label: '#time-diary-alerts' },
  {
    value: '#time-diary-rforrabbit-alerts',
    label: '#time-diary-rforrabbit-alerts',
  },
];

export const bonusFrequencyOptions = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'daily', label: 'Daily' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'half_yearly', label: 'Half Yearly' },
  { value: 'yearly', label: 'Yearly' },
  { value: 'fortnightly', label: 'Fortnightly' },
  { value: 'specific_day_of_week', label: 'Specific Day of Week' },
  { value: 'specific_day_of_month', label: 'Specific Day of Month' },
  { value: 'one-time', label: 'One Time' },
];

export const countryOptions = [
  { value: 'India', label: 'India' },
  { value: 'United States', label: 'United States' },
  { value: 'United Kingdom', label: 'United Kingdom' },
  { value: 'Canada', label: 'Canada' },
  { value: 'Australia', label: 'Australia' },
  { value: 'New Zealand', label: 'New Zealand' },
  { value: 'Netherlands', label: 'Netherlands' },
  { value: 'France', label: 'France' },
  { value: 'Germany', label: 'Germany' },
  { value: 'Spain', label: 'Spain' },
  { value: 'Philippines', label: 'Philippines' },
  { value: 'Singapore', label: 'Singapore' },
  { value: 'Indonesia', label: 'Indonesia' },
  { value: 'Malaysia', label: 'Malaysia' },
];

export const invoiceStatusOptions = [
  { value: 'overdue', label: 'Overdue' },
  { value: 'pending', label: 'Pending' },
  { value: 'paid', label: 'Paid' },
];

export const lineItemTypeOptions = [
  { value: 'service_hours', label: 'Service Hours' },
  { value: 'bonus', label: 'Bonus' },
  { value: 'reimbursement', label: 'Reimbursement' },
  { value: 'penalty', label: 'Penalty' },
  { value: 'adjustment', label: 'Adjustment' },
  { value: 'leave', label: 'Leave' },
  { value: 'other', label: 'Other' },
];

export const sortByOptions = [
  { value: '', label: 'Sort by' },
  { value: 'billDate-asc', label: 'Bill Date ↑' },
  { value: 'billDate-desc', label: 'Bill Date ↓' },
  { value: 'totalAmount-asc', label: 'Total Amount ↑' },
  { value: 'totalAmount-desc', label: 'Total Amount ↓' },
];

export const requirementStatusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'fulfilled', label: 'Fulfilled' },
  { value: 'sourced', label: 'Sourced' },
  { value: 'postponed', label: 'Postponed' },
  { value: 'dropped', label: 'Dropped' },
  { value: 'reopened', label: 'Reopened' },
];

// Permission mapping for frontend routes
export const ROUTE_PERMISSIONS = {
  jobListings: 'jobListings',
  jobApplications: 'jobApplications',
  agents: 'agents',
  agentInvoice: 'invoices',
  mismatchRequests: 'mismatch',
  leaveRequests: 'mismatch',
  // intentionally shares mismatch permission — change value to 'flexi' to decouple access
  flexiRequests: 'mismatch',
  exportLogs: 'logs',
  clients: 'clients',
  clientInvoice: 'invoices',
  rcse: 'requirement',
};

export const permissionRouteMap = {
  jobListings: '/job-listings',
  jobApplications: '/jobs',
  agents: '/agents',
  clients: '/clients',
  invoices: '/agents/invoice',
  logs: '/export-logs',
  requirement: '/clients/rcse',
};

export const general = {
  ROWS_TO_FETCH: 5000,
};

export const COLORS = {
  '': '#FFEAB6',
  InterviewPending: '#166EE1',
  KimSelected: '#FFBA05',
  ClientSelected: '#9AE095',
  ToBeActioned: '#D1E2FF',
  Rejected: '#DC043B',
  NoShow: '#C4ECFF',
  'Candidate-Not-Interested': '#C1F5F0',
  'Hold - Prov Selected': '#CFF5D1',
  Resigned: '#FF9F43',
  SeparatedByOps: '#A855F7',
};

export const allUsers = [
  { label: 'Abhinav', value: 'Abhinav' },
  { label: 'Phani', value: 'Phani' },
  { label: 'Vivek', value: 'Vivek' },
  { label: 'Sachin', value: 'Sachin' },
  { label: 'Kaushik', value: 'Kaushik' },
  { label: 'Palak', value: 'Palak' },
  { label: 'Kuldeep', value: 'Kuldeep' },
  { label: 'Harsh Shah', value: 'Harsh Shah' },
  { label: 'Others', value: 'Others' },
];

export const leadSourceOptions = [
  { label: 'Upwork', value: 'Upwork' },
  { label: 'Inbound', value: 'Inbound' },
  { label: 'Sales', value: 'Sales' },
  { label: 'Others', value: 'Others' },
  { label: 'Customer Success', value: 'Customer-success' },
];

export const priorityOptions = [
  { label: 'High', value: 'high' },
  { label: 'Medium', value: 'medium' },
  { label: 'Low', value: 'low' },
];

export const UPWORK_BRAND_NAME = 'Upwork';